<template>
  <div class="trending-section-wrapper">
    <!-- Two-column layout: 75% left, 23% right, 2% gap, stacks on tablet and below -->
    <div class="grid grid-cols-1 xl:grid-cols-[75%_23%] gap-8 xl:gap-[2%]">
      <!-- Left Column - 75% width (Trending Content) -->
      <div class="xl:col-span-1">
        <TrendingContent :sort="'mixed'" />
      </div>

      <!-- Right Column - 23% width (Trending Players) -->
      <div class="xl:col-span-1">
        <TrendingPlayers :limit="15" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TrendingPlayers from '~/components/trending-players/TrendingPlayers.vue';
import TrendingContent from '~/components/trending-content/TrendingContent.vue';
</script>

<style scoped>
/* Ensure proper spacing and responsive behavior */
.trending-section-wrapper {
  width: 100%;
}
</style>
